import req from '../req'
// 企业微信授权配置

// 企业微信配置-获取配置详情接口
export function getWorkwechat (params) {
  return req.get('/setting/workwechat', params)
}

// 企业微信配置-保存配置详情接口
export function setWorkwechat (params) {
  return req.post('/setting/workwechat', params)
}
